////<template>
////    <ModalWindow v-if="showConvertMyFormAppDialog" v-bind:open="showConvertMyFormAppDialog">
////        <FormConvertFlow slot="body" @close="closeModal"></FormConvertFlow>
////    </ModalWindow>
////</template>
////<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';
import ModalWindow from '/blocks/common/components/modal-window/modal-window.vue';
import { FormConvertFlow } from '/blocks/common/components/form-convert-flow';

export const ConvertMyFormApplication = defineComponent({
    name: 'ConvertMyForm',
        components: {
            ModalWindow,
            FormConvertFlow
        },
        setup() {
            const store = useStore();
            const showConvertMyFormAppDialog = computed(() => store.state.showConvertMyFormAppDialog);
            const closeModal = () => 1;

            return () => (
                <ModalWindow>
                    {/*<FormConvertFlow slot="body"></FormConvertFlow>*/}
                </ModalWindow >
            )
        }
    });

export type ConvertMyFormApplication = InstanceType<typeof ConvertMyFormApplication>
